import { FC } from 'react';
import mainLogo from 'assets/images/main-logo.svg';
import { supportInfo } from './helper';

import './MaintenanceModal.scss';

interface Props {
  message?: string,
}

const ContentMaintenance: FC<Props> = ({ message }) => {

  return (
    <div className="maintenance-modal">
      <img className="maintenance-modal-logo" src={mainLogo} alt="logo" />
      <div className="maintenance-modal-title">{_t('Cables Finance', 'GENERAL.CABLES_FINANCE')}</div>
      <div className="maintenance-modal-conclusion">
        {message
          ? message
          : _t('Cables will be back soon! Follow us on our social media for updates', 'MAINTENANCE_MODE.MODAL_TITLE')
        }
      </div>
      <div className="maintenance-support-links">

        {supportInfo.map((info) => (
          <div className="support-links-row" key={info.link}>
            <span>{info.picture}</span>
            <a
              href={info.link}
              target="_blanck"
              className="maintenance-modal-link"
            >
              {_t(info.translate.defaultText, info.translate.key)}
            </a>
          </div>
        ))}

      </div>
    </div>
  );
};

export default ContentMaintenance;
